<mat-card>
  <mat-card-content>
    <mat-card-title [ngStyle]="{'background-color': backColor, 'color': foreColor, 'padding':'8px','line-height':'15px'}">
      {{data.mode}} password
    </mat-card-title>
    <mat-card-subtitle [ngStyle]="{'background-color': backColor, 'color': foreColor, 'padding-left':'8px'}">
      customer: {{data.customer?.email}}
    </mat-card-subtitle>
  </mat-card-content>
  <form [formGroup]="changePasswordForm">
    <mat-card-content>
      <div class="row">
        <mat-form-field class="w-100">
          <mat-label>New <span *ngIf="data.mode==='reset'">{{data.mode}}</span>  Password</mat-label>
          <input matInput type="password" formControlName="newPassword" required [readonly]="data.mode==='reset'"/>
          <mat-error *ngIf="changePasswordForm.get('newPassword')?.hasError('required')">
            New password is required
          </mat-error>
          <mat-error *ngIf="changePasswordForm.get('newPassword')?.hasError('minlength')">
            Password must be at least 6 characters long
          </mat-error>
        </mat-form-field>
      </div>  
      <div class="row" *ngIf="data.mode==='change'">
        <mat-form-field class="w-100">
          <mat-label>Confirm New Password</mat-label>
          <input matInput type="password" formControlName="confirmPassword" required [readonly]="data.mode==='reset'"/>
          <mat-error *ngIf="changePasswordForm.get('confirmPassword')?.hasError('required')">
            Confirm password is required
          </mat-error>
          <mat-error *ngIf="changePasswordForm.hasError('notMatching')">
            Passwords do not match
          </mat-error>
        </mat-form-field>
      </div>
    </mat-card-content>
    <mat-card-content class="pt-2" appearence="outline">
      <mat-divider></mat-divider>
      <mat-card-content class="pt-2">
        <div style="line-height: 1px !important;padding-top: 2px;">Password will be sent to the customer's email. Are you sure to {{data.mode}} Password
          <mat-icon style="font-size: 15px;padding-top: 10px;">question_mark</mat-icon>
        </div>
      </mat-card-content>
      <mat-card-content>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>varification password</mat-label>
          <input matInput type="password" formControlName="currentPassword" required />
          <mat-error *ngIf="changePasswordForm.get('currentPassword')?.hasError('required')">
            Current password is required
          </mat-error>
        </mat-form-field>
      </mat-card-content>
    </mat-card-content>
    <mat-card-content style="display: flex;justify-content: space-between;">
      <button mat-flat-button [ngStyle]="{'color': backColor}" type="submit" [disabled]="changePasswordForm.invalid" (click)="onSubmit()">
        Change Password
      </button>
      <button mat-button (click)="onCancel()">Cancel</button>
      
    </mat-card-content>
    <mat-card-content>
      {{response}}
    </mat-card-content>
  </form>
</mat-card>


